class Evaluation {
  constructor(el, opt) {
    this.el = el;
    if ($('.' + this.el).length > 0) {
      this.event();
    }
  }

  event(){
		const $links = $('.c-nav-menu .list-wrap a[href^="#"]');
		const pcQuery = window.matchMedia('(min-width: 768px)');
		const spQuery = window.matchMedia('(max-width: 767px)');
		const offset = 120; // ヘッダー分・見出し位置の調整
	
		const targets = [];
	
		$links.each(function () {
			const $link = $(this);
			const id = $link.attr('href');
			const $target = $(id);
	
			if ($target.length) {
				targets.push({
					link: $link,
					target: $target
				});
			}
		});
	
		function clearActive() {
			$links.removeClass('is-active');
		}
	
		function setActive() {
			if (!pcQuery.matches) {
				clearActive();
				return;
			}
	
			const scrollTop = $(window).scrollTop();
			let current = targets[0];
	
			$.each(targets, function (_, item) {
				const targetTop = item.target.offset().top;
	
				if (scrollTop + offset >= targetTop) {
					current = item;
				}
			});
	
			clearActive();
	
			if (current) {
				current.link.addClass('is-active');
			}
		}
	
		$(window).on('scroll resize', setActive);
		setActive();
	
		$links.on('click', function () {
			if (!pcQuery.matches) return;
	
			clearActive();
			$(this).addClass('is-active');
		});

		if (spQuery.matches) {
			$(function(){
				$('.c-nav-menu').click(function(){  //←囲んでる要素
					$(this).find('.list-wrap').slideToggle();  //←開閉したい要素
					$(this).toggleClass('is-open');  //←囲んでる要素にis-openクラスを切り替え
				});
			});
		}
	}
}
